import React, { useState } from "react";
import { useQuery, useQueryClient } from "react-query"
import { useSelector } from "react-redux"
import { useSnackbar } from "notistack"
import SweetAlert from "react-bootstrap-sweetalert"
import 'react-datepicker/dist/react-datepicker.css'

import { Row, Column } from "components/Layout";
import FilterAndSearch from "components/FilterAndSearch";
import Image from "components/Image";
import NTMTable from "components/Table/NTMTable";
import PageWithModal from "components/Page/PageWithModal";
import UserModal from "components/Modal/UserModal";
import { deleteElem, getErrorMessage, post, put, get, USERS, SIGNUP } from "service/Client"
import { roles } from "../../constants"
import { deleteIcon, deleteIcon_over, editIcon, editIcon_over, keyIcon, keyIcon_over } from "img/icons"


export default function AdministrationPage() {

	let [selected, setSelected] = useState(null)
	let [search, setSearch] = useState(null)
	let [alert, setAlert] = useState()
	let [isModalOpen, setModalOpen] = useState(false)
	let [user, setUser] = useState(false)
	let { isLoading, data, error } = useQuery('users', () => get(USERS))
	let queryClient = useQueryClient()
	let loggedUser = useSelector(store => store.users.data)
	const { enqueueSnackbar } = useSnackbar()

	function showError(e) {
		enqueueSnackbar(getErrorMessage(e), { variant: "error" })
	}

	function saveUser(user) {
		setModalOpen(false)
		setUser(null)
		let request = user.id ? put(`${USERS}/${user.id}`, { body: user }) : post(SIGNUP, { body: user })
		request.then(() => queryClient.invalidateQueries("users")).catch(showError)
	}

	function deleteUser(user) {
		setAlert(<SweetAlert
			warning
			showCancel
			cancelBtnText="Annulla"
			confirmBtnText="Ho capito, elimina"
			confirmBtnBsStyle="danger"
			title="Confermi?"
			onConfirm={() => deleteElem(USERS, { elem: user.id })
				.then(() => queryClient.invalidateQueries("users"))
				.catch(showError).finally(() => setAlert(null))
			}
			onCancel={() => setAlert(null)}
			focusCancelBtn
		>
			{`L'utente ${user.firstName} ${user.lastName} sarà eliminato definitivamente e non sarà più possibile recuperarlo`}
		</SweetAlert>)
	}

	function passwordReset(user) {
		setAlert(<SweetAlert
			warning
			showCancel
			cancelBtnText="Annulla"
			confirmBtnText="Ok"
			confirmBtnBsStyle="danger"
			title="Confermi?"
			onConfirm={() => get(`${USERS}/${user.id}/password-reset`)
				.then(() => queryClient.invalidateQueries("users"))
				.catch(showError).finally(() => setAlert(null))
			}
			onCancel={() => setAlert(null)}
			focusCancelBtn
		>
			{`Sarà generata una nuova password per l'utente ${user.firstName} ${user.lastName}`}
		</SweetAlert>)
	}

	if (isLoading) data = []

	if (selected) {
		let selRole = roles.types.find(r => r.name === selected)
		data = data.filter(u => u.role.name === selRole.code)
	}

	if (search) {
		search = search.toLocaleLowerCase()
		data = data.filter(
			u => (u.firstName && u.firstName.toLocaleLowerCase().includes(search)) ||
				(u.lastName && u.lastName.toLocaleLowerCase().includes(search)) ||
				(u.email && u.email.toLocaleLowerCase().includes(search)) ||
				(u.projects && u.projects.map(p => p.name).join().toLocaleLowerCase().includes(search))
		)
	}

	return (
		<PageWithModal
			error={error}
			clear={() => null}
		>
			<FilterAndSearch
				filter={roles.types.map(r => r.name)}
				onFilter={(selected) => setSelected(selected)}
				onSearch={search => setSearch(search)}
				addElement={() => setModalOpen(true)}
				selected={selected}
			/>
			<Row>
				<NTMTable
					header={[
						{
							Header: "NOME",
							accessor: 'firstName',
						},
						{
							Header: "Cognome",
							accessor: 'lastName'
						},
						{
							Header: "email",
							accessor: 'email'
						},
						{
							Header: "telefono",
							accessor: 'phoneNumber'
						},
						{
							Header: "progetti",
							Cell: props =>
								<Column>
									{
										roles.isSuperUser(props.original) || !props.original.projects ?
											"-" :
											props.original.projects.map(p => <div key={p.id}>{p.name}</div>)
									}
								</Column>
						},
						{
							Header: "ruolo",
							accessor: "role.name",
							Cell: props => {
								let role = roles.types.find(r => props.original.role && props.original.role.name === r.code);
								return <div>{role && role.name}</div>;
							}
						},
						{
							Cell: props =>
								<Row style={{ justifyContent: "space-evenly" }}>
									<Image
										src={editIcon}
										hover={editIcon_over}
										onClick={() => { setModalOpen(true); setUser(props.original) }}
									/>
									<Image
										src={keyIcon}
										hover={keyIcon_over}
										onClick={() => passwordReset(props.original)}
									/>
									<Image
										src={deleteIcon}
										hover={deleteIcon_over}
										onClick={() => deleteUser(props.original)}
									/>
								</Row>
						}
					]}
					body={data}
				/>
			</Row>
			<UserModal
				loggedUser={loggedUser}
				defaultValue={user}
				open={isModalOpen}
				onClose={() => { setModalOpen(false); setUser(null) }}
				onSubmit={saveUser}
			/>
			{alert}
		</PageWithModal>
	);
}

